import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SharedMethodsModule } from '../../../../../../insa-custom-scripts';
import { GenericEditorEventProvider } from '../../../GenericEditorStateProvider';
import { FilePickerField } from '../../../models/Field/FilePickerField';

@Component({
  selector: 'file-picker',
  template: `<div [formGroup]="form" class="form-group">
    <label style="display: block;">{{ field.label }}</label>
    <div
      style="display: flex; max-width: 100%;"
      [style.width]="field.size ? field.size + 'em' : ''"
    >
      <button
        [disabled]="(field.isLocked || form.disabled) && !filename"
        (click)="handleFileNamePress($event)"
        [attr.title]="fileName ? 'open' : 'no file selected'"
        type="button"
        class="btn btn-default form-control"
        [ngClass]="
          control.invalid && control.touched ? 'ng-invalid ng-touched' : ''
        "
        style="overflow: hidden; text-overflow: ellipsis;"
        [style.text-align]="field.textAlign"
      >
        {{ fileName ? fileName : 'choose file' }}
      </button>
      <button
        [disabled]="field.isLocked || form.disabled"
        type="button"
        class="btn btn-default form-control"
        style="width: auto; padding: 6px 12px;"
        (click)="handleFilePickerPress($event)"
      >
        {{ fileName ? 'X' : '. . .' }}
      </button>
    </div>
    <input
      [formControlName]="field.key"
      type="file"
      class="form-control"
      style="display: block; margin-right: 15px; max-width: 100%; display: none"
      [style.width]="field.size ? field.size + 1 + 'em' : ''"
      id="{{ field.key + '-file-picker' }}"
      name="{{ field.key + '-file-picker' }}"
      (change)="onChange($event)"
    />
    <error-box [form]="form" [field]="field"></error-box>
  </div>`,
})
export class FilePickerComponent {
  @Input() form: FormGroup;
  @Input() field: FilePickerField;

  reportIsLoaded;
  isModalVisible = false;

  constructor(private eventProvider: GenericEditorEventProvider) {}

  get fileName() {
    return this.field.file.newName || this.field.file.currName || null;
  }

  get fileContent() {
    return this.field.file.newContent || this.field.file.currContent;
  }

  get control() {
    return this.form.controls[this.field.key];
  }

  get inputEl(): HTMLInputElement {
    return document.getElementById(
      this.field.key + '-file-picker'
    ) as HTMLInputElement;
  }

  onChange(event) {
    const file = event.target.files.length ? event.target.files[0] : null;
    this.field.file.newFile = file;
    this.field.file.newName = file ? file.name : null;
    this.field.file.newContent = null;
    this.field.file.currName = null;
    this.field.file.currContent = null;

    if (file) {
      this.form.disable();
      SharedMethodsModule.toBase64(file).subscribe(
        (fileContent: string) => {
          this.field.file.newContent = fileContent;
          this.form.enable();
        },
        () => {
          this.field.file.newContent = null;
          this.form.enable();
          // add an error modal with a message to a user?
        }
      );
    } else {
      this.control.setErrors({ required: true });
    }
    // this.selectedFileName = this.field.file.newName || this.field.file.currName;
    this.control.markAsTouched();
    this.control.markAsDirty();
  }

  handleFilePickerPress(evt) {
    if (this.fileName) {
      // clear the selection and don't open the selector
      evt.preventDefault();
      this.inputEl.value = null;
      this.inputEl.dispatchEvent(new Event('change'));
    } else {
      // open the file selector
      this.inputEl.dispatchEvent(new MouseEvent('click'));
    }
  }

  handleFileNamePress() {
    if (this.fileName) {
      // show file
      this.openFileModal();
    } else {
      // open file selector
      this.inputEl.dispatchEvent(new MouseEvent('click'));
    }
  }

  openFileModal() {
    this.eventProvider.emit({
      name: 'OPEN_FILE_MODAL',
      value: {
        fileContent: this.fileContent,
        fileName: this.fileName,
      },
    });
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/components/fields/file-picker/file-picker.component.ts